import React from 'react';
import { Grid } from '@mui/material';

import { useCCTableContext } from '../cc-table.context';
import { CCTablePagination } from '../cc-table-pagination';
import { CCTableContent } from './cc-table-content';
import { CCTableFilter } from './cc-table-filter';
import { CCTableSorter } from './cc-table-sorter';

export const CCTableMobile = () => {
  const { columns } = useCCTableContext();

  const isFilters = columns.filter(({ filter }) => filter !== false).length > 0;
  const isSorters = columns.filter(({ sorter }) => sorter !== false).length > 0;

  return (
    <Grid container spacing={2}>
      {isFilters && (
        <Grid item xs={12}>
          <CCTableFilter />
        </Grid>
      )}

      {isSorters && (
        <Grid item xs={12}>
          <CCTableSorter />
        </Grid>
      )}

      <Grid item xs={12} sx={{ marginTop: 2 }}>
        <CCTableContent />
      </Grid>

      <Grid item xs={12}>
        <CCTablePagination />
      </Grid>
    </Grid>
  );
};
